import Vue from 'vue'
import Vuex from 'vuex'
import {setObj} from "../plugins/util"
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    record:{
      template:{},
      country:'',
      experiment:null,
      store:{
        id:''
      },
      caseIndex:1,
      storeExpIn:{},
      student:{}
    },
    student:{},
    score:{},
  },
  mutations: {
    setState(state,{dataKey,key,value}){
      if(dataKey){
        state[dataKey] = value
      }else {
        setObj(state,key,value)
      }
    },
    init(state){
      state.record = {
        template:{},
        country:'',
        experiment:null,
        store:{
          id:''
        },
        caseIndex:1,
        storeExpIn:{},
        student:{}
      }
      state.score = {}
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ]
})
